export default __webpack_public_path__ + "static/media/No.7-4.86b659e8.jpg";